import * as d3 from "d3";
import { StatSummary } from "../../../../models/stat";
import { StatToolTip } from "../../InteractiveMap/toolTip";
import { Circle, ICircleCreationEvent } from "../edit/circle";
import ToolProvider from "./toolProvider";

interface IEditEvent {
    background: d3.Selection<any, any, any, any>;
    circleRadius: number;
}

export interface IToolStrategy {
    onClickBackground(
        event: React.MouseEvent<HTMLButtonElement>,
        editEvent: IEditEvent
    ): void;
    onClickCircle(
        circle: Circle,
        event: React.MouseEvent<HTMLButtonElement>,
        callback?: () => void
    ): void;
    onMouseOverCircle(
        event: React.MouseEvent<HTMLButtonElement>,
        stat?: StatSummary
    ): void;
}

export class PenTool implements IToolStrategy {
    private defaultColor = "";
    private creationEvent: ICircleCreationEvent;

    constructor(color: string, creationEvent: ICircleCreationEvent) {
        this.defaultColor = color;
        this.creationEvent = creationEvent;
    }

    onMouseOverCircle(
        event: React.MouseEvent<HTMLButtonElement>,
        stat?: StatSummary
    ): void {
        return;
    }

    onClickCircle(
        circle: Circle,
        event: React.MouseEvent<HTMLButtonElement>
    ): void {
        event.preventDefault();
        this.creationEvent.openPopup();
        ToolProvider.GetInstance()?.setTarget(circle);
    }

    onClickBackground(
        event: React.MouseEvent<HTMLButtonElement>,
        editEvent: IEditEvent
    ): void {
        event.preventDefault();
        const [x, y] = d3.pointer(event);
        const { background, circleRadius } = editEvent;
        const circle = new Circle(
            background,
            x,
            y,
            circleRadius,
            this.defaultColor
        );
        circle
            .create()
            .applyAnimations()
            .on("click", (event) => {
                ToolProvider.GetInstance()?.tool?.onClickCircle(circle, event);
            });
    }
}

export class EraserTool implements IToolStrategy {
    onMouseOverCircle(
        event: React.MouseEvent<HTMLButtonElement>,
        stat?: StatSummary
    ): void {
        return;
    }
    onClickCircle(
        circle: Circle,
        event: React.MouseEvent<HTMLButtonElement>,
        callback: () => void
    ): void {
        event.preventDefault();
        circle.remove();
    }
    onClickBackground(
        event: React.MouseEvent<HTMLButtonElement>,
        editEvent: IEditEvent
    ): void {
        return;
    }
}

export class ViewOnlyTool implements IToolStrategy {
    tooltip: StatToolTip;
    hoverReset: () => void;

    constructor(toolTip: StatToolTip, hoverReset: () => void) {
        this.tooltip = toolTip;
        this.hoverReset = hoverReset;
    }
    onClickCircle(
        circle: Circle,
        event: React.MouseEvent<HTMLButtonElement>,
        callback: () => void
    ): void {
        event.preventDefault();
        callback();
    }
    onMouseOverCircle(
        event: React.MouseEvent<HTMLButtonElement>,
        stat?: StatSummary
    ): void {
        event.preventDefault();
        this.hoverReset();
        if (!stat) return;
        this.tooltip.populate(stat.roomName, stat.minutes);
        this.tooltip.show(event.pageX, event.pageY);
    }

    onClickBackground(
        event: React.MouseEvent<HTMLButtonElement>,
        editEvent: IEditEvent
    ): void {
        return;
    }
}
